import React from 'react';
import { connect } from 'react-redux';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, { LOG_LEVELS } from '../../../utils/logger';

const log = new Logger('FORMATTED_CURRENCY_VALUE', LOG_LEVELS.ERROR);

// TODO: Add support for showing currency symbol, brackets for -ve numbers, decimal & thousands separator, etc

export class FormattedCurrencyValue extends React.Component {
  constructor(props) {
    super(props);
    this.formatToCurrency = this.formatToCurrency.bind(this);
    this.state = {
      number: props.value
    };
  }

  formatToCurrency() {
    const currencyValue = parseFloat(this.state.number);
    const invalidNumber = isNaN(currencyValue);
    const formattedNumber = invalidNumber ?
      LANGUAGES_CONTROLLER.format(this.props.languages, 'conversionError_invalidCurrencyValue') :
      currencyValue.toFixed(this.props.decimalPlaces);

    this.setState({
      number: formattedNumber
    });
  }

  componentDidMount() {
    this.setState({
      number: this.props.value
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        number: this.props.value
      });
    }
  }

  changeHandler(event) {
    let changedValue;
    if (this.props.editOptions) {
      if (!this.props.editOptions.fieldName) {
        changedValue = event.target.value !== '' ? event.target.value : undefined;
      }
      else {
        changedValue = {};
        changedValue[this.props.editOptions.fieldName] = event.target.value !== '' ? event.target.value : undefined;
      }
      this.setState({
        number: changedValue[this.props.editOptions.fieldName]
      });
      this.props.editOptions.changeHandler(changedValue);
    }
  }

  render() {
    const rightAlignClassName = this.props.rightAlign ? ' text-align-right ' : '';
    const spanClassName = ['formatted-currency mt0', this.props.className, rightAlignClassName, this.props.inputFieldClassName || ''].join(' ');
    if (this.props.editOptions) {
      return (
        <div
          className={['formatted-currency mt0', this.props.className, rightAlignClassName].join(' ')}>
          <input
            type='number'
            className={this.props.inputFieldClassName || ''}
            value={this.state.number}
            placeholder={this.props.editOptions.prompt || ''}
            onChange={this.changeHandler.bind(this)}
            onBlur={this.formatToCurrency}
            data-testid='formatted-currency-input'
          />
        </div>
      )
    }
    const currencyValue = parseFloat(this.props.value);
    const invalidNumber = isNaN(currencyValue);
    const formattedNumber = invalidNumber ?
      LANGUAGES_CONTROLLER.format(this.props.languages, 'conversionError_invalidCurrencyValue') :
      currencyValue.toFixed(this.props.decimalPlaces);
    return (
      <span
        className={spanClassName}
        data-testid='formatted-currency'>
        {formattedNumber}
      </span>
    );

  }
}

function mapStateToProps(state) {
  return {
    languages: state.languages
  };
}


FormattedCurrencyValue.defaultProps = {
  decimalPlaces: 2,
  rightAlign: true,
  className: ''
};

// Wrap the component to inject state into it
export default connect(mapStateToProps)(FormattedCurrencyValue);